















import { Component, Vue } from "vue-property-decorator";
import getUrlParam from '@/common/utils/getUrlParam';
@Component
export default class CheckFooter extends Vue{

  getUrlParam: Function = getUrlParam;
  
}
